import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cp } from "fs";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { Collapse } from "react-bootstrap";
import { CPReactMethods } from "../app";
import { CPPartDisplay } from "../models/CPPart";

export interface PartDisplayProps {
    part: CPPartDisplay
    isPreview: boolean
    isPublic: boolean
    submitAnswer(part: CPPartDisplay, tempPartIndex: number): any
    problemIndex: number
    partIndex: number
    changeAnswer(partIndex: number, answer: string): any
    changeExponent(partIndex: number, exponent: string): any
    isLastAnswerCorrect(part: CPPartDisplay): any
    isOutOfAttempts(part: CPPartDisplay): any
    isAnswerAlreadySubmitted(part: CPPartDisplay): any
    isAnswerAlreadySubmittedAndCorrect(part: CPPartDisplay): any
    isOnePartProblem: boolean
    canSubmitLate: boolean
    lateSubmissionPenalty?: number
    latePenaltyDate?: Date
    isSubmittable: boolean
}

const PartDisplay = (props: PartDisplayProps) => {
    const [inputCursor, setInputCursor] = useState<number | null>(null)
    const [exponentCursor, setExponentCursor] = useState<number | null>(null)
    const inputRef = useRef(null);
    const exponentRef = useRef(null);
    const [showAttempts, setShowAttempts] = useState(false)
    const [showInfo, setShowInfo] = useState(false)

    useEffect(() => {
        const input = inputRef.current;
        if (input && inputCursor != null) {
            // @ts-ignore
            input.setSelectionRange(inputCursor, inputCursor);
        }
    }, [inputRef, inputCursor])

    useEffect(() => {
        const input = exponentRef.current;
        if (input && exponentCursor) {
            // @ts-ignore
            input.setSelectionRange(exponentCursor, exponentCursor);
        }
    }, [exponentRef, exponentCursor])

    const getOptionDisplayFromValue = (value: number) => {
        if (props.part.multipleChoice) {
            try {
                var index = props.part.options!.findIndex(option => option.value == value)
                return props.part.options![index].text
            }
            catch (ex) {
                return value
            }
        }
        return value
    }

    return (

        <li style={{ listStyle: props.isOnePartProblem ? "none" : "" }}>
            <div className="row">
                <div className="col">
                    <div className="row">
                        <div className="col" dangerouslySetInnerHTML={{ __html: props.part.text || "" }}></div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-auto">
                            <div className="row">


                                {props.part.multipleChoice ?
                                    <>
                                        <div className="col-auto" dangerouslySetInnerHTML={{ __html: props.part.answerLabel }}>
                                        </div>
                                        <div className="col-auto">
                                            {props.part.options ?
                                                props.part.options.map((option, optionIndex) => {
                                                    return (
                                                        <div className="form-check" key={optionIndex}>
                                                            <input disabled={!props.isSubmittable} role="button" className="form-check-input" type="radio" name={"problem" + props.problemIndex + "part" + props.partIndex + "option" + optionIndex + "radio"} id={"problem" + props.problemIndex + "part" + props.partIndex + "option" + optionIndex} value={option.value} checked={props.part.answers[props.part.answers.length - 1] != undefined ? props.part.answers[props.part.answers.length - 1].answer == option.value : false} onChange={e => props.changeAnswer(props.partIndex, e.currentTarget.value)} />
                                                            <label className="form-check-label" htmlFor={"problem" + props.problemIndex + "part" + props.partIndex + "option" + optionIndex}>{option.text}</label>
                                                        </div>
                                                    )
                                                }) : ""}
                                        </div>
                                        <div className="col-auto" dangerouslySetInnerHTML={{ __html: props.part.unitsLabel }}>
                                        </div>
                                    </>
                                    /* Creates a select box
                                    <select className="form-select" value={answers[problemIndex].parts[partIndex].attempts[answers[problemIndex].parts[partIndex].attempts.length - 1].answer} onChange={e => changeAnswer(problemIndex, partIndex, e.currentTarget.value)}>
                                        {part.options.map(option => {
                                            return (
                                                <option key={option.text} value={option.value}>{option.text}</option>
                                            )
                                        })}
                                    </select>*/

                                    :
                                    <div className="col-auto">
                                        <div className="input-group mb-3">
                                            {!CPReactMethods.isNullOrWhiteSpace(props.part.answerLabel) ?
                                                <span className="input-group-text px-1" >
                                                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: props.part.answerLabel }}>
                                                        </p>
                                                </span> : ""}
                                            <input disabled={!props.isSubmittable} ref={inputRef} type="text" className="form-control answerInput" value={props.part.answers[props.part.answers.length - 1] ? props.part.answers[props.part.answers.length - 1].answer ?? "" : ""} onChange={e => { setInputCursor(e.target.selectionStart); props.changeAnswer(props.partIndex, e.currentTarget.value); }} />
                                            {props.part.scientificNotation ?
                                                <>
                                                    <span className="input-group-text px-1">
                                                        x10^
                                                    </span>
                                                    <input disabled={!props.isSubmittable} ref={exponentRef} type="text" className="form-control exponentInput" value={props.part.answers[props.part.answers.length - 1] ? props.part.answers[props.part.answers.length - 1].exponentValue ?? "" : ""} onChange={e => { setExponentCursor(e.target.selectionStart); props.changeExponent(props.partIndex, e.currentTarget.value); }} />
                                                </> : ""}
                                            {!CPReactMethods.isNullOrWhiteSpace(props.part.unitsLabel) ?
                                                <span className="input-group-text px-1">
                                                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: props.part.unitsLabel }}>
                                                    </p>
                                                </span> : ""}
                                        </div>
                                    </div>
                                }
                                {props.isLastAnswerCorrect(props.part) || props.isAnswerAlreadySubmittedAndCorrect(props.part) ?
                                    <div className="col-auto">
                                        <FontAwesomeIcon icon={faCheck} size="2x" color='green' />
                                    </div> :
                                    props.isAnswerAlreadySubmitted(props.part) ?
                                        <div className="col-auto">
                                            <FontAwesomeIcon icon={faXmark} size="2x" color="red" />
                                        </div> : ""}

                                <div className="col-auto">
                                    {!CPReactMethods.isNullOrUndefined(props.part.value) ?
                                        <div className="col-auto">
                                            Calculated Answer: {props.part.value}
                                        </div> : ""
                                    }
                                    {!CPReactMethods.isNullOrUndefined(props.part.min) ?
                                        <div className="col-auto">
                                            Min Answer: {props.part.min}
                                        </div> : ""
                                    }
                                    {!CPReactMethods.isNullOrUndefined(props.part.value) ?
                                        <div className="col-auto">
                                            Max Answer: {props.part.max}
                                        </div> : ""
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="row">
                                {!props.isPublic ?
                                    <div className="col col-auto text-center position-relative">
                                        <a href="javascript:void(0)" title={showInfo ? "Hide Info" : "Show Info"} onClick={() => { setShowInfo(!showInfo); setShowAttempts(false); }}>
                                            Info
                                        </a>
                                        <Collapse in={showInfo}>
                                            <div className="card p-2 row position-absolute infoTooltip">
                                                <div className="col">
                                                    <div className="row text-nowrap">
                                                        Points: {props.part.points}
                                                    </div>
                                                    <div className="row text-nowrap">
                                                        Unpenalized Attempts: {props.part.unpenalizedAttempts == 0 ? "∞" : props.part.unpenalizedAttempts}
                                                    </div>
                                                    <div className="row text-nowrap">
                                                        Penalty per Penalized Attempt: {props.part.penalty}%
                                                    </div>
                                                    {props.canSubmitLate ?
                                                        <div className="row text-nowrap">
                                                            Late Submission Penalty: {props.lateSubmissionPenalty}%
                                                        </div>
                                                        : ""}
                                                    {props.latePenaltyDate ?
                                                        <div className="row text-nowrap">
                                                            Submittable as Late Before: {props.latePenaltyDate.toDateString() + " " + props.latePenaltyDate.toLocaleTimeString()}
                                                        </div> : ""}
                                                </div>
                                            </div>
                                        </Collapse>
                                    </div>
                                    : ""}
                                <div className="col col-auto text-center position-relative">
                                    <a href="javascript:void(0)" title={showAttempts ? "Hide Attempts" : "Show Attempts"} onClick={() => { setShowAttempts(!showAttempts); setShowInfo(false); }}>

                                        {"Attempts: " + props.part.answers.filter(attempt => attempt.isSubmitted).length.toString() + (props.isPublic ? "" : "/" + (props.part.maxAttempts != 0 ? props.part.maxAttempts!.toString() : String.fromCharCode(8734)))}
                                    </a>
                                    {props.part.answers.length > 0 && props.part.answers[0].isSubmitted ?
                                        <Collapse in={showAttempts}>
                                            <div className="card p-2 row position-absolute infoTooltip">
                                                <div className="col">
                                                    {props.part.answers.map((attempt, attemptIndex) => {
                                                        if (attempt.isSubmitted) {
                                                            return (
                                                                <div className="row" key={attemptIndex}>
                                                                    <div className={attempt.isCorrect ? "col text-center text-success" : "col text-center text-danger"}>{props.part.multipleChoice ? getOptionDisplayFromValue(attempt.answer) : attempt.answer * Math.pow(10, attempt.exponentValue ?? 0)}</div>
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </Collapse> : ""}
                                </div>
                                {props.isSubmittable ?
                                    <div className="col">
                                        <button disabled={props.isLastAnswerCorrect(props.part) || props.isOutOfAttempts(props.part)} type="button" className="btn btn-primary rounded" onClick={() => props.submitAnswer(props.part, props.partIndex)}>Submit</button>
                                    </div>
                                    : ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>

    )
}

export default PartDisplay